import React, { useEffect, useState } from 'react';
import parkerPreview from '../cad/generateCAD';
import {
  Grid,
  MenuItem,
  Select,
  Button,
  OutlinedInput,
  Alert
} from '@mui/material';
import '../assets/css/cad.css';
import Search from '@mui/icons-material/Search';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import loader from '../assets/images/loader.gif';

function CAD(props) {
  const {
    mident,
    translations,
    isManifoldProduct,
    sessionDataItems,
    partNumberString,
    catalog,
    partNumber,
    partSolutionsAPI,
    bomItems,
    uniquePartIdentifier
  } = props;
  const [activeTab, setActiveTab] = useState('preview');
  const [activePreviewTab, setActivePreviewTab] = useState('');
  const [cadXMLData, setCadXMLData] = useState();
  const [cadXMLDataFilter, setCadXMLDataFilter] = useState();
  const [validationMessage, setvalidationMessage] = useState('Test Message');
  const [validationMessageColor, setValidationMessageColor] =
    useState('#D32F2F');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (mident && mident?.length != 0) {
      setActivePreviewTab('3D');
      setActiveTab('preview');
      document.getElementById('3DView').style.display = 'block';
      document.getElementById('2DView').style.display = 'none';

      document.getElementById('cnsWebViewer3d').innerHTML = '';

      setvalidationMessage(translations.ALERT_MESSAGE_INFO);
      parkerPreview.GeneratePreviewView(
        '3D',
        mident,
        isManifoldProduct,
        partSolutionsAPI,
        sessionDataItems,
        partNumberString,
        true
      );
      document.getElementById('cadPreview').style.display = 'block';
      document.getElementById('cadFormats').style.display = 'none';
    }
  }, [mident]);

  const get2DView = () => {
    document.getElementById('3DView').style.display = 'none';
    document.getElementById('2DView').style.display = 'block';
    setActivePreviewTab('2D');
    parkerPreview.GeneratePreviewView(
      '2D',
      mident,
      isManifoldProduct,
      partSolutionsAPI,
      sessionDataItems,
      partNumberString,
      false
    );
  };
  const get3DView = () => {
    document.getElementById('3DView').style.display = 'block';
    document.getElementById('2DView').style.display = 'none';
    setActivePreviewTab('3D');
    parkerPreview.GeneratePreviewView(
      '3D',
      mident,
      isManifoldProduct,
      partSolutionsAPI,
      sessionDataItems,
      partNumberString,
      false
    );
  };

  const generateCAD = async () => {
    if (
      document.querySelectorAll('input[data-type="cad"]:checked').length == 0
    ) {
      setvalidationMessage(translations.ALERT_MESSAGE_INFO);
      setValidationMessageColor('#D32F2F');
    } else {
      setIsLoading(true);

      setvalidationMessage(translations.ALERT_MESSAGE_LOAD);
      setValidationMessageColor('#0076CC');
      var cadType = document.querySelector(
        'input[data-type="cad"]:checked'
      ).value;

      var cadName = document.querySelector('input[data-type="cad"]:checked').id;

      await parkerPreview.GenerateCADDownload(
        cadType,
        mident,
        partNumber,
        catalog,
        cadName,
        sessionDataItems.manufacturingDivision,
        partNumberString,
        isManifoldProduct,
        bomItems,
        sessionDataItems.configModel,
        uniquePartIdentifier
      );
      setIsLoading(false);

      setvalidationMessage(translations.ALERT_MESSAGE_SUCCESS);
      setValidationMessageColor('#388E3C');
    }
  };
  const generatePDF = async () => {
    setvalidationMessage(translations.ALERT_MESSAGE_LOAD_PDF);
    setValidationMessageColor('#0076CC');
    setIsLoading(true);
    await parkerPreview.GenerateCADDownload(
      'PDFDATASHEET',
      mident,
      partNumber,
      catalog,
      'pdf',
      sessionDataItems.manufacturingDivision,
      partNumberString,
      isManifoldProduct,
      bomItems,
      sessionDataItems.configModel,
      uniquePartIdentifier
    );

    setvalidationMessage(translations.ALERT_MESSAGE_SUCCESS_PDF);
    setValidationMessageColor('#388E3C');

    setIsLoading(false);
  };
  const resetCAD = () => {
    if (document.querySelectorAll('input[name=cadType]:checked').length > 0) {
      document.querySelector('input[name=cadType]:checked').checked = false;

      setvalidationMessage(translations.ALERT_MESSAGE_RESET);
    }
  };
  const getPreviewDetails = () => {
    setActiveTab('preview');
    document.getElementById('cadPreview').style.display = 'block';
    document.getElementById('cadFormats').style.display = 'none';
  };

  const getCADDetails = () => {
    setActiveTab('formats');
    document.getElementById('cadPreview').style.display = 'none';
    document.getElementById('cadFormats').style.display = 'block';
    var cadData;
    fetch('https://webapi.qa.partcommunity.com/cadqualifier.asp')
      .then(response => {
        // this.cadXML = response.text();
        return response.text();
      })
      .then(cadXML => {
        const xmlDocument = new DOMParser().parseFromString(cadXML, 'text/xml');
        cadData = xmlDocument.querySelectorAll('format');
        var tableData = '';
        for (var ctrlrow = 0; ctrlrow < cadData.length; ctrlrow++) {
          if (ctrlrow % 2 == 0) {
            tableData +=
              '<tr><td><input type="radio" style="margin-right:.5rem !important;" data-type="cad" name="cadType" id = "' +
              cadData[ctrlrow].children[0].textContent +
              ' ' +
              cadData[ctrlrow].children[1].textContent +
              ' (' +
              cadData[ctrlrow].attributes[0].value.toUpperCase() +
              ')' +
              '" data-model="' +
              cadData[ctrlrow].attributes[0].value +
              '" value="' +
              cadData[ctrlrow].children[2].textContent +
              '" />';
            if (cadData[ctrlrow].attributes[0].value.toUpperCase() == '3D')
              tableData +=
                '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"/></svg>';
            else
              tableData +=
                '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"/></svg>';

            tableData +=
              '<label style="margin-left:.5rem !important;" class="m-0">' +
              cadData[ctrlrow].children[0].textContent +
              ' ' +
              cadData[ctrlrow].children[1].textContent +
              ' (' +
              cadData[ctrlrow].attributes[0].value.toUpperCase() +
              ')' +
              '</label></td>';
          } else {
            tableData +=
              '<td><input type="radio" style="margin-right:.5rem !important;" data-type="cad" name="cadType" id = "' +
              cadData[ctrlrow].children[0].textContent +
              ' ' +
              cadData[ctrlrow].children[1].textContent +
              ' (' +
              cadData[ctrlrow].attributes[0].value.toUpperCase() +
              ')' +
              '" data-model="' +
              cadData[ctrlrow].attributes[0].value +
              '" value="' +
              cadData[ctrlrow].children[2].textContent +
              '"/>';
            if (cadData[ctrlrow].attributes[0].value.toUpperCase() == '3D')
              tableData +=
                '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"/></svg>';
            else
              tableData +=
                '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"/></svg>';

            tableData +=
              '<label style="margin-left:.5rem !important;" class="m-0">' +
              cadData[ctrlrow].children[0].textContent +
              ' ' +
              cadData[ctrlrow].children[1].textContent +
              ' (' +
              cadData[ctrlrow].attributes[0].value.toUpperCase() +
              ')' +
              '</label></td></tr>';
          }
        }

        setvalidationMessage(translations.ALERT_MESSAGE_INFO);

        document.getElementById('cadDataTable').innerHTML = tableData;
        document.querySelectorAll("input[data-type='cad']").forEach(input => {
          input.addEventListener('change', cadTypeSelect);
        });
        tableData = '<table><tbody>' + tableData + '</tbody></table>';
        setCadXMLData(new DOMParser().parseFromString(tableData, 'text/html'));
        setCadXMLDataFilter(
          new DOMParser().parseFromString(tableData, 'text/html')
        );
      });
  };

  const cadTypeSelect = () => {
    setvalidationMessage(translations.CAD_FORMAT_DOWNLOAD);
    setValidationMessageColor('#0076CC');
  };

  const cadFormatFilter = e => {
    var filter, tr, td, cell, i, j;
    filter = e.target.value;
    document.getElementById('searchCAD').value = '';
    tr = cadXMLData.getElementsByTagName('tr');
    var k = 0;
    var tableData = '';
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName('td');
      for (j = 0; j < td.length; j++) {
        cell = tr[i].getElementsByTagName('td')[j];
        if (cell) {
          if (
            cell
              .querySelector('input[data-model]')
              .dataset.model.toUpperCase() == filter ||
            filter == 'All'
          ) {
            if (k % 2 == 0) {
              tableData += '<tr><td>' + cell.innerHTML + '</td>';
            } else {
              tableData += '<td>' + cell.innerHTML + '</td></tr>';
            }
            k++;
          }
        }
      }
    }
    document.getElementById('cadDataTable').innerHTML = tableData;
    tableData = '<table><tbody>' + tableData + '</tbody></table>';
    setCadXMLDataFilter(
      new DOMParser().parseFromString(tableData, 'text/html')
    );
  };

  const cadFormatSearch = () => {
    var input, filter, tr, td, cell, i, j;
    input = document.getElementById('searchCAD');
    filter = input.value.toUpperCase();

    tr = cadXMLDataFilter.getElementsByTagName('tr');
    var k = 0;
    var tableData = '';
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName('td');
      for (j = 0; j < td.length; j++) {
        cell = tr[i].getElementsByTagName('td')[j];
        if (cell) {
          if (
            cell
              .querySelector('label')
              .innerHTML.toUpperCase()
              .indexOf(filter) > -1
          ) {
            if (k % 2 == 0) {
              tableData += '<tr><td>' + cell.innerHTML + '</td>';
            } else {
              tableData += '<td>' + cell.innerHTML + '</td></tr>';
            }
            k++;
          }
        }
      }
    }
    document.getElementById('cadDataTable').innerHTML = tableData;
  };

  const partNumberFound = () => {
    if (!mident) return false;
    else return true;
  };

  const getPascalCaseTranslation = () => {
    var translation = translations.FORMATS;

    var lowerCaseTranslation = translation.toLowerCase();
    var firstChar = lowerCaseTranslation.substring(0, 1);
    var remainingString = lowerCaseTranslation.substring(
      1,
      lowerCaseTranslation.length
    );
    var pascalCaseString = firstChar.toUpperCase() + remainingString;
    return pascalCaseString;
  };

  return (
    <div className="cad-view">
      {!partNumberFound() ? (
        <div>
          <Alert
            sx={{ bgcolor: validationMessageColor }}
            severity="error"
            className="cad-alert-message mx-3 mt-3"
          >
            The requested part number could not be found
          </Alert>
        </div>
      ) : (
        <div>
          <div className="d-flex align-items-stretch align-content-stretch cad-menu">
            <a
              onClick={() => getPreviewDetails()}
              className={
                activeTab == 'preview'
                  ? 'active display-flex justify-center'
                  : 'display-flex justify-center'
              }
            >
              <RemoveRedEyeIcon className="preview-icon" />
              <span className="preview-text"> {translations.PREVIEW} </span>
            </a>
            <a
              onClick={() => getCADDetails()}
              className={activeTab == 'formats' ? 'active ml-2' : 'ml-2'}
            >
              <span> {getPascalCaseTranslation()}</span>
            </a>
          </div>
          <div className="cad-preview rel-position" id="cadPreview">
            <div className="d-flex align-items-stretch align-content-stretch cad-sub-menu mx-3">
              <div className={activePreviewTab == '3D' ? 'active' : ''}>
                <a onClick={() => get3DView()}>3D</a>
              </div>
              <div className={activePreviewTab == '2D' ? 'active' : ''}>
                <a onClick={() => get2DView()}>2D</a>
              </div>
            </div>
            <div id="3DView">
              <div id="container">
                <div id="cnsWebViewerContainer">
                  <div id="cnsWebViewer3d"></div>
                </div>
              </div>
            </div>
            {activePreviewTab == 'dimension' && <div>dimension</div>}
            <div id="2DView">
              <div id="container">
                <div id="cnsWebViewerContainer">
                  <div id="cnsWebViewer2d"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="cad-formats" id="cadFormats">
            <div>
              <div className="d-flex align-items-stretch align-content-stretch mx-3"></div>
              <div>
                <Alert
                  sx={{ bgcolor: validationMessageColor }}
                  severity="info"
                  className="cad-alert-message mx-3 mt-3"
                >
                  {validationMessage}
                </Alert>
                <div className="row controls">
                  {/* <div className="col-12 p-0 div-text">CAD_SELECT_TEXT</div> */}
                  <Grid container>
                    <Grid item xs={12} className="div-text">
                      {translations.CAD_SELECT_TEXT}
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Select
                        id="cadFilter"
                        className="cad-filter"
                        onChange={e => cadFormatFilter(e)}
                        defaultValue="All"
                      >
                        <MenuItem value="All">
                          {translations.CAD_FILTER_ALL}
                        </MenuItem>
                        <MenuItem value="3D">
                          {translations.CAD_FILTER_ALL_3D}
                        </MenuItem>
                        <MenuItem value="2D">
                          {translations.CAD_FILTER_ALL_2D}
                        </MenuItem>
                      </Select>
                    </Grid>

                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      className="cad-search-border"
                    >
                      <div className="cad-search-group">
                        <OutlinedInput
                          id="searchCAD"
                          placeholder="Search.."
                          onChange={() => cadFormatSearch()}
                          className="cad-search-box"
                        />

                        <Search className="cad-search-icon" />
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className="row controls mt-3">
                  <Grid container>
                    <Grid item xs={12} sm={4} md={4} lg={4}>
                      <Button
                        className="btn btn-custom btn-cad"
                        onClick={() => resetCAD()}
                      >
                        {translations.REFRESH_CAD}
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                      className="cad-button-padding"
                    >
                      <Button
                        className="btn btn-custom btn-cad btnGenerateDataSheet"
                        onClick={() => generatePDF()}
                      >
                        {translations.GENERATE_DATA_SHEET_PDF}
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                      className="cad-button-padding"
                    >
                      <Button
                        className="btn btn-custom btn-cad btnGenerateCad"
                        onClick={() => generateCAD()}
                      >
                        {translations.GENERATE_CAD}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
                <div className="row controls mt-3 format-options">
                  <table
                    className="table table-sm table-hover table-striped table-borderless mt-2 cad-table"
                    id="cadDataTable"
                  >
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {isLoading && (
            <div>
              <div className="loading-overlay">
                <div className="loader-text">
                  <img src={loader} />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CAD;
